import styled from 'styled-components';
// import image from '../shared/img.png';
import {fonts,mediaQueries} from "../shared/config";

const Box = styled("div")`
display: flex;
flex-direction: row;
height: auto;
align-items: center;
margin-bottom: 40px;
${mediaQueries.tablet} {
    flex-direction: column;
  }
${mediaQueries.mobile}{
    flex-direction: column;
  }
`;

const Text = styled("div")`
font-family: Staatliches;
color: white;
font-size: 25px;
align-items: center;
text-align: center;
margin-left: 40px;
margin-right: 40px;
padding-left: 40px;
padding-right: 40px;
width: 100%;
${mediaQueries.mobile}{
    padding-top: 30px;
  }
`;

const Image = styled("img")`
width: 100%;
height: auto;
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
  color: white;
`;

export default function ImageWithPullquote(props) {
    return (
  
        <Box>
        <div>
          <Image src={props.image} alt=""></Image>
          <Credits>{props.credits}</Credits>
        </div>
        
        <Text>{props.quote}</Text>
        
        </Box>
  
    );
}

